import { Coin } from "../../cosmos/base/v1beta1/coin";
import * as _m0 from "protobufjs/minimal";
import { Long } from "@osmonauts/helpers";
export let DepositRecord_Status;
(function (DepositRecord_Status) {
  DepositRecord_Status[DepositRecord_Status["TRANSFER_QUEUE"] = 0] = "TRANSFER_QUEUE";
  DepositRecord_Status[DepositRecord_Status["TRANSFER_IN_PROGRESS"] = 2] = "TRANSFER_IN_PROGRESS";
  DepositRecord_Status[DepositRecord_Status["DELEGATION_QUEUE"] = 1] = "DELEGATION_QUEUE";
  DepositRecord_Status[DepositRecord_Status["DELEGATION_IN_PROGRESS"] = 3] = "DELEGATION_IN_PROGRESS";
  DepositRecord_Status[DepositRecord_Status["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DepositRecord_Status || (DepositRecord_Status = {}));
export let DepositRecord_StatusSDKType;
(function (DepositRecord_StatusSDKType) {
  DepositRecord_StatusSDKType[DepositRecord_StatusSDKType["TRANSFER_QUEUE"] = 0] = "TRANSFER_QUEUE";
  DepositRecord_StatusSDKType[DepositRecord_StatusSDKType["TRANSFER_IN_PROGRESS"] = 2] = "TRANSFER_IN_PROGRESS";
  DepositRecord_StatusSDKType[DepositRecord_StatusSDKType["DELEGATION_QUEUE"] = 1] = "DELEGATION_QUEUE";
  DepositRecord_StatusSDKType[DepositRecord_StatusSDKType["DELEGATION_IN_PROGRESS"] = 3] = "DELEGATION_IN_PROGRESS";
  DepositRecord_StatusSDKType[DepositRecord_StatusSDKType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DepositRecord_StatusSDKType || (DepositRecord_StatusSDKType = {}));
export function depositRecord_StatusFromJSON(object) {
  switch (object) {
    case 0:
    case "TRANSFER_QUEUE":
      return DepositRecord_Status.TRANSFER_QUEUE;
    case 2:
    case "TRANSFER_IN_PROGRESS":
      return DepositRecord_Status.TRANSFER_IN_PROGRESS;
    case 1:
    case "DELEGATION_QUEUE":
      return DepositRecord_Status.DELEGATION_QUEUE;
    case 3:
    case "DELEGATION_IN_PROGRESS":
      return DepositRecord_Status.DELEGATION_IN_PROGRESS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DepositRecord_Status.UNRECOGNIZED;
  }
}
export function depositRecord_StatusToJSON(object) {
  switch (object) {
    case DepositRecord_Status.TRANSFER_QUEUE:
      return "TRANSFER_QUEUE";
    case DepositRecord_Status.TRANSFER_IN_PROGRESS:
      return "TRANSFER_IN_PROGRESS";
    case DepositRecord_Status.DELEGATION_QUEUE:
      return "DELEGATION_QUEUE";
    case DepositRecord_Status.DELEGATION_IN_PROGRESS:
      return "DELEGATION_IN_PROGRESS";
    default:
      return "UNKNOWN";
  }
}
export let DepositRecord_Source;
(function (DepositRecord_Source) {
  DepositRecord_Source[DepositRecord_Source["STRIDE"] = 0] = "STRIDE";
  DepositRecord_Source[DepositRecord_Source["WITHDRAWAL_ICA"] = 1] = "WITHDRAWAL_ICA";
  DepositRecord_Source[DepositRecord_Source["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DepositRecord_Source || (DepositRecord_Source = {}));
export let DepositRecord_SourceSDKType;
(function (DepositRecord_SourceSDKType) {
  DepositRecord_SourceSDKType[DepositRecord_SourceSDKType["STRIDE"] = 0] = "STRIDE";
  DepositRecord_SourceSDKType[DepositRecord_SourceSDKType["WITHDRAWAL_ICA"] = 1] = "WITHDRAWAL_ICA";
  DepositRecord_SourceSDKType[DepositRecord_SourceSDKType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(DepositRecord_SourceSDKType || (DepositRecord_SourceSDKType = {}));
export function depositRecord_SourceFromJSON(object) {
  switch (object) {
    case 0:
    case "STRIDE":
      return DepositRecord_Source.STRIDE;
    case 1:
    case "WITHDRAWAL_ICA":
      return DepositRecord_Source.WITHDRAWAL_ICA;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DepositRecord_Source.UNRECOGNIZED;
  }
}
export function depositRecord_SourceToJSON(object) {
  switch (object) {
    case DepositRecord_Source.STRIDE:
      return "STRIDE";
    case DepositRecord_Source.WITHDRAWAL_ICA:
      return "WITHDRAWAL_ICA";
    default:
      return "UNKNOWN";
  }
}
export let HostZoneUnbonding_Status;
(function (HostZoneUnbonding_Status) {
  HostZoneUnbonding_Status[HostZoneUnbonding_Status["UNBONDING_QUEUE"] = 0] = "UNBONDING_QUEUE";
  HostZoneUnbonding_Status[HostZoneUnbonding_Status["UNBONDING_IN_PROGRESS"] = 3] = "UNBONDING_IN_PROGRESS";
  HostZoneUnbonding_Status[HostZoneUnbonding_Status["EXIT_TRANSFER_QUEUE"] = 1] = "EXIT_TRANSFER_QUEUE";
  HostZoneUnbonding_Status[HostZoneUnbonding_Status["EXIT_TRANSFER_IN_PROGRESS"] = 4] = "EXIT_TRANSFER_IN_PROGRESS";
  HostZoneUnbonding_Status[HostZoneUnbonding_Status["CLAIMABLE"] = 2] = "CLAIMABLE";
  HostZoneUnbonding_Status[HostZoneUnbonding_Status["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(HostZoneUnbonding_Status || (HostZoneUnbonding_Status = {}));
export let HostZoneUnbonding_StatusSDKType;
(function (HostZoneUnbonding_StatusSDKType) {
  HostZoneUnbonding_StatusSDKType[HostZoneUnbonding_StatusSDKType["UNBONDING_QUEUE"] = 0] = "UNBONDING_QUEUE";
  HostZoneUnbonding_StatusSDKType[HostZoneUnbonding_StatusSDKType["UNBONDING_IN_PROGRESS"] = 3] = "UNBONDING_IN_PROGRESS";
  HostZoneUnbonding_StatusSDKType[HostZoneUnbonding_StatusSDKType["EXIT_TRANSFER_QUEUE"] = 1] = "EXIT_TRANSFER_QUEUE";
  HostZoneUnbonding_StatusSDKType[HostZoneUnbonding_StatusSDKType["EXIT_TRANSFER_IN_PROGRESS"] = 4] = "EXIT_TRANSFER_IN_PROGRESS";
  HostZoneUnbonding_StatusSDKType[HostZoneUnbonding_StatusSDKType["CLAIMABLE"] = 2] = "CLAIMABLE";
  HostZoneUnbonding_StatusSDKType[HostZoneUnbonding_StatusSDKType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(HostZoneUnbonding_StatusSDKType || (HostZoneUnbonding_StatusSDKType = {}));
export function hostZoneUnbonding_StatusFromJSON(object) {
  switch (object) {
    case 0:
    case "UNBONDING_QUEUE":
      return HostZoneUnbonding_Status.UNBONDING_QUEUE;
    case 3:
    case "UNBONDING_IN_PROGRESS":
      return HostZoneUnbonding_Status.UNBONDING_IN_PROGRESS;
    case 1:
    case "EXIT_TRANSFER_QUEUE":
      return HostZoneUnbonding_Status.EXIT_TRANSFER_QUEUE;
    case 4:
    case "EXIT_TRANSFER_IN_PROGRESS":
      return HostZoneUnbonding_Status.EXIT_TRANSFER_IN_PROGRESS;
    case 2:
    case "CLAIMABLE":
      return HostZoneUnbonding_Status.CLAIMABLE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return HostZoneUnbonding_Status.UNRECOGNIZED;
  }
}
export function hostZoneUnbonding_StatusToJSON(object) {
  switch (object) {
    case HostZoneUnbonding_Status.UNBONDING_QUEUE:
      return "UNBONDING_QUEUE";
    case HostZoneUnbonding_Status.UNBONDING_IN_PROGRESS:
      return "UNBONDING_IN_PROGRESS";
    case HostZoneUnbonding_Status.EXIT_TRANSFER_QUEUE:
      return "EXIT_TRANSFER_QUEUE";
    case HostZoneUnbonding_Status.EXIT_TRANSFER_IN_PROGRESS:
      return "EXIT_TRANSFER_IN_PROGRESS";
    case HostZoneUnbonding_Status.CLAIMABLE:
      return "CLAIMABLE";
    default:
      return "UNKNOWN";
  }
}
export let LSMTokenDeposit_Status;
(function (LSMTokenDeposit_Status) {
  LSMTokenDeposit_Status[LSMTokenDeposit_Status["DEPOSIT_PENDING"] = 0] = "DEPOSIT_PENDING";
  LSMTokenDeposit_Status[LSMTokenDeposit_Status["TRANSFER_QUEUE"] = 1] = "TRANSFER_QUEUE";
  LSMTokenDeposit_Status[LSMTokenDeposit_Status["TRANSFER_IN_PROGRESS"] = 2] = "TRANSFER_IN_PROGRESS";
  LSMTokenDeposit_Status[LSMTokenDeposit_Status["TRANSFER_FAILED"] = 3] = "TRANSFER_FAILED";
  LSMTokenDeposit_Status[LSMTokenDeposit_Status["DETOKENIZATION_QUEUE"] = 4] = "DETOKENIZATION_QUEUE";
  LSMTokenDeposit_Status[LSMTokenDeposit_Status["DETOKENIZATION_IN_PROGRESS"] = 5] = "DETOKENIZATION_IN_PROGRESS";
  LSMTokenDeposit_Status[LSMTokenDeposit_Status["DETOKENIZATION_FAILED"] = 6] = "DETOKENIZATION_FAILED";
  LSMTokenDeposit_Status[LSMTokenDeposit_Status["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LSMTokenDeposit_Status || (LSMTokenDeposit_Status = {}));
export let LSMTokenDeposit_StatusSDKType;
(function (LSMTokenDeposit_StatusSDKType) {
  LSMTokenDeposit_StatusSDKType[LSMTokenDeposit_StatusSDKType["DEPOSIT_PENDING"] = 0] = "DEPOSIT_PENDING";
  LSMTokenDeposit_StatusSDKType[LSMTokenDeposit_StatusSDKType["TRANSFER_QUEUE"] = 1] = "TRANSFER_QUEUE";
  LSMTokenDeposit_StatusSDKType[LSMTokenDeposit_StatusSDKType["TRANSFER_IN_PROGRESS"] = 2] = "TRANSFER_IN_PROGRESS";
  LSMTokenDeposit_StatusSDKType[LSMTokenDeposit_StatusSDKType["TRANSFER_FAILED"] = 3] = "TRANSFER_FAILED";
  LSMTokenDeposit_StatusSDKType[LSMTokenDeposit_StatusSDKType["DETOKENIZATION_QUEUE"] = 4] = "DETOKENIZATION_QUEUE";
  LSMTokenDeposit_StatusSDKType[LSMTokenDeposit_StatusSDKType["DETOKENIZATION_IN_PROGRESS"] = 5] = "DETOKENIZATION_IN_PROGRESS";
  LSMTokenDeposit_StatusSDKType[LSMTokenDeposit_StatusSDKType["DETOKENIZATION_FAILED"] = 6] = "DETOKENIZATION_FAILED";
  LSMTokenDeposit_StatusSDKType[LSMTokenDeposit_StatusSDKType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LSMTokenDeposit_StatusSDKType || (LSMTokenDeposit_StatusSDKType = {}));
export function lSMTokenDeposit_StatusFromJSON(object) {
  switch (object) {
    case 0:
    case "DEPOSIT_PENDING":
      return LSMTokenDeposit_Status.DEPOSIT_PENDING;
    case 1:
    case "TRANSFER_QUEUE":
      return LSMTokenDeposit_Status.TRANSFER_QUEUE;
    case 2:
    case "TRANSFER_IN_PROGRESS":
      return LSMTokenDeposit_Status.TRANSFER_IN_PROGRESS;
    case 3:
    case "TRANSFER_FAILED":
      return LSMTokenDeposit_Status.TRANSFER_FAILED;
    case 4:
    case "DETOKENIZATION_QUEUE":
      return LSMTokenDeposit_Status.DETOKENIZATION_QUEUE;
    case 5:
    case "DETOKENIZATION_IN_PROGRESS":
      return LSMTokenDeposit_Status.DETOKENIZATION_IN_PROGRESS;
    case 6:
    case "DETOKENIZATION_FAILED":
      return LSMTokenDeposit_Status.DETOKENIZATION_FAILED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return LSMTokenDeposit_Status.UNRECOGNIZED;
  }
}
export function lSMTokenDeposit_StatusToJSON(object) {
  switch (object) {
    case LSMTokenDeposit_Status.DEPOSIT_PENDING:
      return "DEPOSIT_PENDING";
    case LSMTokenDeposit_Status.TRANSFER_QUEUE:
      return "TRANSFER_QUEUE";
    case LSMTokenDeposit_Status.TRANSFER_IN_PROGRESS:
      return "TRANSFER_IN_PROGRESS";
    case LSMTokenDeposit_Status.TRANSFER_FAILED:
      return "TRANSFER_FAILED";
    case LSMTokenDeposit_Status.DETOKENIZATION_QUEUE:
      return "DETOKENIZATION_QUEUE";
    case LSMTokenDeposit_Status.DETOKENIZATION_IN_PROGRESS:
      return "DETOKENIZATION_IN_PROGRESS";
    case LSMTokenDeposit_Status.DETOKENIZATION_FAILED:
      return "DETOKENIZATION_FAILED";
    default:
      return "UNKNOWN";
  }
}
function createBaseUserRedemptionRecord() {
  return {
    id: "",
    sender: "",
    receiver: "",
    amount: "",
    denom: "",
    hostZoneId: "",
    epochNumber: Long.UZERO,
    claimIsPending: false
  };
}
export const UserRedemptionRecord = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.sender !== "") {
      writer.uint32(18).string(message.sender);
    }
    if (message.receiver !== "") {
      writer.uint32(26).string(message.receiver);
    }
    if (message.amount !== "") {
      writer.uint32(34).string(message.amount);
    }
    if (message.denom !== "") {
      writer.uint32(42).string(message.denom);
    }
    if (message.hostZoneId !== "") {
      writer.uint32(50).string(message.hostZoneId);
    }
    if (!message.epochNumber.isZero()) {
      writer.uint32(56).uint64(message.epochNumber);
    }
    if (message.claimIsPending === true) {
      writer.uint32(64).bool(message.claimIsPending);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserRedemptionRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.id = reader.string();
          break;
        case 2:
          message.sender = reader.string();
          break;
        case 3:
          message.receiver = reader.string();
          break;
        case 4:
          message.amount = reader.string();
          break;
        case 5:
          message.denom = reader.string();
          break;
        case 6:
          message.hostZoneId = reader.string();
          break;
        case 7:
          message.epochNumber = reader.uint64();
          break;
        case 8:
          message.claimIsPending = reader.bool();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$id, _object$sender, _object$receiver, _object$amount, _object$denom, _object$hostZoneId, _object$claimIsPendin;
    const message = createBaseUserRedemptionRecord();
    message.id = (_object$id = object.id) !== null && _object$id !== void 0 ? _object$id : "";
    message.sender = (_object$sender = object.sender) !== null && _object$sender !== void 0 ? _object$sender : "";
    message.receiver = (_object$receiver = object.receiver) !== null && _object$receiver !== void 0 ? _object$receiver : "";
    message.amount = (_object$amount = object.amount) !== null && _object$amount !== void 0 ? _object$amount : "";
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.hostZoneId = (_object$hostZoneId = object.hostZoneId) !== null && _object$hostZoneId !== void 0 ? _object$hostZoneId : "";
    message.epochNumber = object.epochNumber !== undefined && object.epochNumber !== null ? Long.fromValue(object.epochNumber) : Long.UZERO;
    message.claimIsPending = (_object$claimIsPendin = object.claimIsPending) !== null && _object$claimIsPendin !== void 0 ? _object$claimIsPendin : false;
    return message;
  }
};
function createBaseDepositRecord() {
  return {
    id: Long.UZERO,
    amount: "",
    denom: "",
    hostZoneId: "",
    status: 0,
    depositEpochNumber: Long.UZERO,
    source: 0
  };
}
export const DepositRecord = {
  encode(message, writer = _m0.Writer.create()) {
    if (!message.id.isZero()) {
      writer.uint32(8).uint64(message.id);
    }
    if (message.amount !== "") {
      writer.uint32(18).string(message.amount);
    }
    if (message.denom !== "") {
      writer.uint32(26).string(message.denom);
    }
    if (message.hostZoneId !== "") {
      writer.uint32(34).string(message.hostZoneId);
    }
    if (message.status !== 0) {
      writer.uint32(48).int32(message.status);
    }
    if (!message.depositEpochNumber.isZero()) {
      writer.uint32(56).uint64(message.depositEpochNumber);
    }
    if (message.source !== 0) {
      writer.uint32(64).int32(message.source);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDepositRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.id = reader.uint64();
          break;
        case 2:
          message.amount = reader.string();
          break;
        case 3:
          message.denom = reader.string();
          break;
        case 4:
          message.hostZoneId = reader.string();
          break;
        case 6:
          message.status = reader.int32();
          break;
        case 7:
          message.depositEpochNumber = reader.uint64();
          break;
        case 8:
          message.source = reader.int32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$amount2, _object$denom2, _object$hostZoneId2, _object$status, _object$source;
    const message = createBaseDepositRecord();
    message.id = object.id !== undefined && object.id !== null ? Long.fromValue(object.id) : Long.UZERO;
    message.amount = (_object$amount2 = object.amount) !== null && _object$amount2 !== void 0 ? _object$amount2 : "";
    message.denom = (_object$denom2 = object.denom) !== null && _object$denom2 !== void 0 ? _object$denom2 : "";
    message.hostZoneId = (_object$hostZoneId2 = object.hostZoneId) !== null && _object$hostZoneId2 !== void 0 ? _object$hostZoneId2 : "";
    message.status = (_object$status = object.status) !== null && _object$status !== void 0 ? _object$status : 0;
    message.depositEpochNumber = object.depositEpochNumber !== undefined && object.depositEpochNumber !== null ? Long.fromValue(object.depositEpochNumber) : Long.UZERO;
    message.source = (_object$source = object.source) !== null && _object$source !== void 0 ? _object$source : 0;
    return message;
  }
};
function createBaseHostZoneUnbonding() {
  return {
    stTokenAmount: "",
    nativeTokenAmount: "",
    denom: "",
    hostZoneId: "",
    unbondingTime: Long.UZERO,
    status: 0,
    userRedemptionRecords: []
  };
}
export const HostZoneUnbonding = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.stTokenAmount !== "") {
      writer.uint32(10).string(message.stTokenAmount);
    }
    if (message.nativeTokenAmount !== "") {
      writer.uint32(18).string(message.nativeTokenAmount);
    }
    if (message.denom !== "") {
      writer.uint32(26).string(message.denom);
    }
    if (message.hostZoneId !== "") {
      writer.uint32(34).string(message.hostZoneId);
    }
    if (!message.unbondingTime.isZero()) {
      writer.uint32(40).uint64(message.unbondingTime);
    }
    if (message.status !== 0) {
      writer.uint32(48).int32(message.status);
    }
    for (const v of message.userRedemptionRecords) {
      writer.uint32(58).string(v);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseHostZoneUnbonding();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.stTokenAmount = reader.string();
          break;
        case 2:
          message.nativeTokenAmount = reader.string();
          break;
        case 3:
          message.denom = reader.string();
          break;
        case 4:
          message.hostZoneId = reader.string();
          break;
        case 5:
          message.unbondingTime = reader.uint64();
          break;
        case 6:
          message.status = reader.int32();
          break;
        case 7:
          message.userRedemptionRecords.push(reader.string());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$stTokenAmount, _object$nativeTokenAm, _object$denom3, _object$hostZoneId3, _object$status2, _object$userRedemptio;
    const message = createBaseHostZoneUnbonding();
    message.stTokenAmount = (_object$stTokenAmount = object.stTokenAmount) !== null && _object$stTokenAmount !== void 0 ? _object$stTokenAmount : "";
    message.nativeTokenAmount = (_object$nativeTokenAm = object.nativeTokenAmount) !== null && _object$nativeTokenAm !== void 0 ? _object$nativeTokenAm : "";
    message.denom = (_object$denom3 = object.denom) !== null && _object$denom3 !== void 0 ? _object$denom3 : "";
    message.hostZoneId = (_object$hostZoneId3 = object.hostZoneId) !== null && _object$hostZoneId3 !== void 0 ? _object$hostZoneId3 : "";
    message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? Long.fromValue(object.unbondingTime) : Long.UZERO;
    message.status = (_object$status2 = object.status) !== null && _object$status2 !== void 0 ? _object$status2 : 0;
    message.userRedemptionRecords = ((_object$userRedemptio = object.userRedemptionRecords) === null || _object$userRedemptio === void 0 ? void 0 : _object$userRedemptio.map(e => e)) || [];
    return message;
  }
};
function createBaseEpochUnbondingRecord() {
  return {
    epochNumber: Long.UZERO,
    hostZoneUnbondings: []
  };
}
export const EpochUnbondingRecord = {
  encode(message, writer = _m0.Writer.create()) {
    if (!message.epochNumber.isZero()) {
      writer.uint32(8).uint64(message.epochNumber);
    }
    for (const v of message.hostZoneUnbondings) {
      HostZoneUnbonding.encode(v, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEpochUnbondingRecord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.epochNumber = reader.uint64();
          break;
        case 3:
          message.hostZoneUnbondings.push(HostZoneUnbonding.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$hostZoneUnbon;
    const message = createBaseEpochUnbondingRecord();
    message.epochNumber = object.epochNumber !== undefined && object.epochNumber !== null ? Long.fromValue(object.epochNumber) : Long.UZERO;
    message.hostZoneUnbondings = ((_object$hostZoneUnbon = object.hostZoneUnbondings) === null || _object$hostZoneUnbon === void 0 ? void 0 : _object$hostZoneUnbon.map(e => HostZoneUnbonding.fromPartial(e))) || [];
    return message;
  }
};
function createBaseLSMTokenDeposit() {
  return {
    chainId: "",
    denom: "",
    ibcDenom: "",
    stakerAddress: "",
    validatorAddress: "",
    amount: "",
    stToken: undefined,
    status: 0
  };
}
export const LSMTokenDeposit = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.chainId !== "") {
      writer.uint32(10).string(message.chainId);
    }
    if (message.denom !== "") {
      writer.uint32(18).string(message.denom);
    }
    if (message.ibcDenom !== "") {
      writer.uint32(26).string(message.ibcDenom);
    }
    if (message.stakerAddress !== "") {
      writer.uint32(34).string(message.stakerAddress);
    }
    if (message.validatorAddress !== "") {
      writer.uint32(42).string(message.validatorAddress);
    }
    if (message.amount !== "") {
      writer.uint32(50).string(message.amount);
    }
    if (message.stToken !== undefined) {
      Coin.encode(message.stToken, writer.uint32(58).fork()).ldelim();
    }
    if (message.status !== 0) {
      writer.uint32(64).int32(message.status);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseLSMTokenDeposit();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.chainId = reader.string();
          break;
        case 2:
          message.denom = reader.string();
          break;
        case 3:
          message.ibcDenom = reader.string();
          break;
        case 4:
          message.stakerAddress = reader.string();
          break;
        case 5:
          message.validatorAddress = reader.string();
          break;
        case 6:
          message.amount = reader.string();
          break;
        case 7:
          message.stToken = Coin.decode(reader, reader.uint32());
          break;
        case 8:
          message.status = reader.int32();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$chainId, _object$denom4, _object$ibcDenom, _object$stakerAddress, _object$validatorAddr, _object$amount3, _object$status3;
    const message = createBaseLSMTokenDeposit();
    message.chainId = (_object$chainId = object.chainId) !== null && _object$chainId !== void 0 ? _object$chainId : "";
    message.denom = (_object$denom4 = object.denom) !== null && _object$denom4 !== void 0 ? _object$denom4 : "";
    message.ibcDenom = (_object$ibcDenom = object.ibcDenom) !== null && _object$ibcDenom !== void 0 ? _object$ibcDenom : "";
    message.stakerAddress = (_object$stakerAddress = object.stakerAddress) !== null && _object$stakerAddress !== void 0 ? _object$stakerAddress : "";
    message.validatorAddress = (_object$validatorAddr = object.validatorAddress) !== null && _object$validatorAddr !== void 0 ? _object$validatorAddr : "";
    message.amount = (_object$amount3 = object.amount) !== null && _object$amount3 !== void 0 ? _object$amount3 : "";
    message.stToken = object.stToken !== undefined && object.stToken !== null ? Coin.fromPartial(object.stToken) : undefined;
    message.status = (_object$status3 = object.status) !== null && _object$status3 !== void 0 ? _object$status3 : 0;
    return message;
  }
};